import { IconQuestionMarkCircle } from '@gto/ui/assets'
import { Tooltip } from '@gto/ui/tooltip'

import type { EarningDeal } from '@/api/gen'

import { EdgeTiersLegend } from './edge-tiers-legend'

/** Just the tier fields, so any row shape carrying them can render this. */
type EdgeTiersTooltipProps = Pick<EarningDeal, 'current_tier' | 'tier_structure'>

export const EdgeTiersTooltip = ({ current_tier, tier_structure }: EdgeTiersTooltipProps) => {
  return (
    <div className="inline-flex items-center hover:cursor-pointer hover:text-primary-main">
      <Tooltip
        className="min-w-[320px] p-0"
        content={
          <EdgeTiersLegend
            currentTier={current_tier}
            tiers={tier_structure}
          />
        }
      >
        <IconQuestionMarkCircle />
      </Tooltip>
    </div>
  )
}
